import React, { useState, useRef } from "react";
import apiClient from "../../../../services/api-client";
import { Toast } from 'primereact/toast';
import AppFormSelect from '../../../../components/ui/AppFormSelect';
import AppFormInput from '../../../../components/ui/AppFormInput';
import AppButton from '../../../../components/ui/AppButton';
import AppSkeleton from '../../../../components/ui/AppSkeleton';
import { InputSwitch } from "primereact/inputswitch";
import { useMountEffect } from 'primereact/hooks';
import { MultiSelect } from 'primereact/multiselect';
import { Editor } from "primereact/editor";
import StorageHelper from '../../../../utils/storage-helper';


const GroupActivation = ({ onCloseDialog }) => {
    const [groupName, setGroupName] = useState(null);
    const [groupStatus, setGroupStatus] = useState(true);
    const [termsAndConditions, setTermsAndConditions] = useState('');
    const [groupImage, setGroupImage] = useState('');
    const [loading, setLoading] = useState(false);
    const [groupOptions, setGroupOptions] = useState([]);
    const [groupProducts, setGroupProducts] = useState([]);

    const [categoryName, setCategoryName] = useState('')

    const categories = [
        "Legal aid",
        "Group life assurance",
        "Cash plan",
        "Funeral policy",
    ]
    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    };
    const header = renderHeader();
    const [selectedGroupProducts, setSelectedGroupProducts] = useState(null);
    const toast = useRef(null);


    useMountEffect(() => {
        fetchLocalGroups()
    });


    const fetchLocalGroups = async () => {
        let productGroup = []
        await apiClient.get('policy/products/group', {
            headers: {
                Authorization: 'Bearer ' + StorageHelper.get('token'),
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            response.data.responseBody.forEach(element => {

                if (typeof element != 'undefined') {
                    productGroup.push(element)
                }

            });
        }).catch((e) => {

        });

        setGroupOptions(productGroup)

    }





    const handleSubmit = (e) => {
        e.preventDefault();

        postProduct()
    };


    const postProduct = async () => {

        let readyProductList = []
        selectedGroupProducts.forEach((element) => {
            readyProductList.push({ productID: element.ProductID })
        })

        let prodObj = []
        readyProductList.forEach((elementProduct) => {

            //console.log(elementProduct)
            prodObj.push({
                "productID": elementProduct.productID,
                "productExtensions": []
            })

        })
        let productPayload = {
            "accessToken": "",
            "operation": "SaveActivePlansProducts",
            "requestBody": {

                "easipolSubGroupId": groupName.SubGroupID,
                "activeStatus": groupStatus,
                "category": categoryName,
                "productsList": prodObj,
                "groupImageBannerUrl": groupImage,
                "termAndConditions": termsAndConditions
            }
        };

        const token = StorageHelper.get('token')

        const config = {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        };

        try {
            const response = await apiClient.post('policy/products/active', productPayload, config);
            //console.log(response.data);
            if (response.data.status === 'SUCCESS') {
                await toast.current.show({ severity: 'success', sticky: true, summary: 'SUCCESS', detail: response.data.message });
                window.location.reload();
            } else {

                toast.current.show({ severity: 'error', sticky: true, summary: 'Failed', detail: response.data.message });
            }
        } catch (error) {
            console.error(error);
        }
    };


    async function fetchProductsPerGroup(id) {
        setLoading(true)
        await apiClient.get('policy/products/group/easipol/' + id, {
            headers: {
                Authorization: 'Bearer ' + StorageHelper.get('token'),
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                setLoading(false)
                setGroupProducts(response.data.responseBody)
            })
            .catch()
    }

    const handleGroupChange = (val) => {
        setGroupName(val.value)
        setGroupProducts([])
        setSelectedGroupProducts(null)
        //console.log(val.value.SubGroupID)
        fetchProductsPerGroup(val.value.SubGroupID)
    }

    const handleCategoryChange = (val) => {
        setCategoryName(val.value)
        //console.log(val.value.SubGroupID)
    }

    const handleSyncEasipol = async () => {
        setLoading(true)
        await apiClient.get('policy/products/easipol', {
            headers: {
                Authorization: 'Bearer ' + StorageHelper.get('token'),
                'Content-Type': 'application/json'
            }
        }).then(async (response) => {
            if (response.data.status === "SUCCESS") {
                setLoading(false)
                await apiClient.get('policy/products/group/easipol', {
                    headers: {
                        Authorization: 'Bearer ' + StorageHelper.get('token'),
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    if (response.data.status === "SUCCESS") {
                        toast.current.show({ severity: 'success', summary: 'SUCCESS', detail: 'Products synchronization completed' });
                    }
                })

            }
        })
    }
    return (
        
        <>
            <Toast ref={toast} />
            <div className="w-full flex flex-col gap-4 mt-2">
                <div className="flex justify-end mb-2">
                    <button className="btn btn-sm btn-outline btn-info rounded-full" onClick={handleSyncEasipol}>
                        {loading ? <span className="loading loading-spinner loading-xs"></span> : <i className="pi pi-sync"></i>}
                        <span className="ml-1">Sync Easipol</span>
                    </button>
                </div>

                <AppFormSelect
                    label="Subgroup"
                    id="groupName"
                    value={groupName}
                    options={groupOptions}
                    optionLabel="Description"
                    onChange={(e) => {
                        // find the original object because handleGroupChange expects an object like {value: group}
                        const selectedOption = groupOptions.find(opt => (opt.value || opt) === e.target.value);
                        handleGroupChange({value: selectedOption || e.target.value});
                    }}
                    placeholder="Select a Subgroup"
                />

                <AppFormInput
                    label="Group Image URL"
                    id="groupImage"
                    value={groupImage}
                    onChange={(e) => setGroupImage(e.target.value)}
                    placeholder="Paste image url"
                />

                {loading === false ? (
                    <>
                        <div className="form-control w-full">
                            <label className="label"><span className="label-text font-semibold text-gray-700">Select Products to Activate</span></label>
                            <MultiSelect 
                                value={selectedGroupProducts} 
                                onChange={(e) => setSelectedGroupProducts(e.value)} 
                                options={groupProducts} 
                                optionLabel="ProductName1" 
                                className="w-full" 
                                placeholder="Choose products" 
                                display="chip" 
                            />
                        </div>

                        <AppFormSelect
                            label="Product Category"
                            id="categoryName"
                            value={categoryName}
                            options={categories}
                            onChange={(e) => handleCategoryChange({value: e.target.value})}
                            placeholder="Select a category"
                        />

                        <div className="form-control w-full">
                            <label className="label"><span className="label-text font-semibold text-gray-700">Group Terms & Conditions</span></label>
                            <Editor 
                                placeholder="Group terms and conditions" 
                                value={termsAndConditions} 
                                headerTemplate={header} 
                                onTextChange={(e) => setTermsAndConditions(e.htmlValue)} 
                                style={{ minHeight: '150px' }} 
                            />
                        </div>

                        <div className="form-control w-full mt-2">
                            <label className="label cursor-pointer justify-start gap-4 p-4 border border-base-200 rounded-lg bg-base-50/50 hover:bg-base-100 transition-colors">
                                <InputSwitch
                                    id="value"
                                    name="value"
                                    checked={groupStatus}
                                    onChange={(e) => {
                                        let message = !groupStatus ? 'Product will be created active' : 'Product will be created disabled';
                                        toast.current.show({ severity: 'info', summary: 'Group Status', detail: message });
                                        setGroupStatus(e.value);
                                    }}
                                />
                                <span className="label-text font-medium text-gray-700">
                                    {groupStatus ? 'Create and set it disabled?' : 'Activate group upon creation?'}
                                </span>
                            </label>
                        </div>

                        <div className="mt-6 flex justify-end pt-4 border-t border-base-200">
                            <AppButton variant="primary" icon="pi pi-check" onClick={handleSubmit}>
                                Save Product Group
                            </AppButton>
                        </div>
                    </>
                ) : (
                    <div className="flex flex-col gap-4 mt-4 w-full">
                        <AppSkeleton height="3rem" className="rounded-lg" />
                        <AppSkeleton height="3rem" className="rounded-lg" />
                        <AppSkeleton height="8rem" className="rounded-lg" />
                    </div>
                )}
            </div>
        </>
    );
};

export default GroupActivation;
